import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private http: HttpClient) {}

  async downloadFile(url: string, fileName: string, type:string) {
    this.downloadBuffer(
      await (await fetch(url)).arrayBuffer(), fileName, type
    )
  }

  /**
   * Método específico para download de templates que evita cache
   * Usa uma abordagem que não sofre com CORS
   */
  downloadTemplate(url: string, fileName: string, type: string = 'docx') {
    // Adiciona parâmetros anti-cache na URL
    const separator = url.includes('?') ? '&' : '?';
    const cacheBusterUrl = `${url}${separator}_t=${Date.now()}&_nocache=1`;
    
    // Cria um elemento <a> temporário para fazer o download
    const link = document.createElement('a');
    link.href = cacheBusterUrl;
    link.download = fileName;
    link.target = '_blank';
    
    // Adiciona atributos para forçar o download sem cache
    link.setAttribute('download', fileName);
    link.setAttribute('rel', 'noopener noreferrer');
    
    // Adiciona o link ao DOM temporariamente
    document.body.appendChild(link);
    
    // Simula o clique
    link.click();
    
    // Remove o link do DOM
    document.body.removeChild(link);
  }

  downloadBuffer(arrayBuffer:any, fileName: string, type:string ) {
    const typeBlobs: { [key: string]: string }  = {
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'pdf': 'application/pdf'
    }
    const ext = `.${type}`;
    const finalName = fileName.toLowerCase().endsWith(ext.toLowerCase()) ? fileName : `${fileName}${ext}`;
    const a = document.createElement('a')
    a.href = URL.createObjectURL(new Blob(
      [ arrayBuffer ],
      { type: typeBlobs[type] }
    ))
    a.download = finalName
    a.click()
  }

}
